// Line items with sub-points. The API returns a flat list in print order; a
// row with a parentId is a description-only sub-point of that parent.

interface FlatItem {
  id: string;
  parentId?: string | null;
  position: number;
}

export function groupItems<T extends FlatItem>(items: T[] = []): Array<{ item: T; children: T[] }> {
  const ordered = [...items].sort((a, b) => a.position - b.position);
  return ordered
    .filter((row) => !row.parentId)
    .map((item) => ({ item, children: ordered.filter((row) => row.parentId === item.id) }));
}

/** Stored items → the form's shape, for hydrating an edit page. */
export function itemsToForm(items: Array<FlatItem & { description: string; quantity: number | string; unitPrice: number | string; taxRate: number | string }> = []) {
  return groupItems(items).map(({ item, children }) => ({
    description: item.description,
    quantity: Number(item.quantity),
    unitPrice: Number(item.unitPrice),
    taxRate: Number(item.taxRate) || 0,
    children: children.map((c) => ({ description: c.description })),
  }));
}

/** Blank sub-points are dropped — the API refuses an empty description. */
export function cleanChildren(children?: Array<{ description: string }>) {
  return (children ?? []).map((c) => ({ description: c.description.trim() })).filter((c) => c.description);
}
